import {
	Component,
	ChangeDetectionStrategy,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';
import {
	ACTION_TYPES,
	COLUMN_TYPES,
} from '@app/shared/ui-components/au-table-layout/utils/enums';
import { ICMMSColumn } from '@app/shared/ui-components/au-table-layout/utils/interfaces';
import { CmmsPages } from '../../state/cmms.reducer';
import { ICmmsAsset } from '@app/pages/cmms/interfaces/assets.interfaces';
import { iconEnum } from '@app/configs/model/IconEnum';
import { AuExpansionPanelModule } from '@app/shared/ui-components/au-expansion-panel/au-expansion-panel.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { AuTableLayoutModule } from '@app/shared/ui-components';

import { MatButtonModule } from '@angular/material/button';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { OpenDtFromWorkspaceComponent } from '../shared-form-group-controls/cmms-open-dt-from-workspace/open-dt-from-workspace.component';

@Component({
	selector: 'assets-section',
	templateUrl: './assets-section.component.html',
	styleUrls: ['./assets-section.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		AuExpansionPanelModule,
		MatMenuModule,
		MatIconModule,
		AuTableLayoutModule,
		MatButtonModule,
		NgxTolgeeModule,
		OpenDtFromWorkspaceComponent,
	],
})
export class AssetsSectionComponent {
	@Input() set assets(data: ICmmsAsset[]) {
		this.dataForTable = data;
		this.isPanelOpen = !!this.dataForTable?.length;
	}

	@Output() openAssets = new EventEmitter<void>();
	@Output() newAsset = new EventEmitter<CmmsPages>();
	@Output() unlink = new EventEmitter<{ data: ICmmsAsset }>();
	@Output() rowSelect = new EventEmitter<{
		data: any;
		entityType: CmmsPages;
	}>();

	dataForTable: ICmmsAsset[] = [];
	isPanelOpen: boolean;
	readonly iconEnum = iconEnum;

	readonly tableColumns: ICMMSColumn[] = [
		{
			head: 'Name',
			key: 'name',
			type: COLUMN_TYPES.BODY_HEADING,
			isSortable: false,
		},
		{
			head: 'Location',
			key: 'location',
			type: COLUMN_TYPES.LOCATIONS,
			isSortable: false,
		},
		// TODO: Uncomment when there will be data for columns
		// {
		// 	head: 'Serial Number',
		// 	key: 'status',
		// 	type: COLUMN_TYPES.GREY_TEXT,
		// 	isSortable: false,
		// },
		// {
		// 	head: 'Manufacturer',
		// 	key: 'priority',
		// 	type: COLUMN_TYPES.GREY_TEXT,
		// 	isSortable: false,
		// },
		{
			head: 'emty_head',
			key: '',
			type: COLUMN_TYPES.ACTION,
			isSortable: false,
			customData: {
				actions: [ACTION_TYPES.UNLINK, ACTION_TYPES.OPEN_IN_DT],
			},
		},
	];

	openAttachAssets(event: Event) {
		event.stopPropagation();
		this.openAssets.emit();
	}

	addNew() {
		this.newAsset.next(CmmsPages.newAsset);
	}

	viewEntity(event) {
		this.rowSelect.emit({ data: event, entityType: CmmsPages.editAsset });
	}
}
